var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media",on:{"click":_vm.act}},[_c('b-icon',{staticClass:"media-left",attrs:{"icon":"edit","size":"is-small"}}),_c('span',[_vm._v("Edit metadata")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }